import { Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApeDrawerComponent } from "../ape-drawer/ape-drawer.component";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";
import { LoggerService } from "../../../ancestors/logger.service";
import { SvgIconComponent } from "angular-svg-icon";

/**
 * Componente sidenav per la sezione supporto.
 * Mostra contatti email e una sezione "Guide e Materiali" con un testo
 * informativo (rimando a PixartInside > Per me > GPS).
 */
@Component({
  selector: "ape-support-sidenav",
  standalone: true,
  imports: [
    CommonModule,
    ApeDrawerComponent,
    TranslatePipe,
    SvgIconComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./ape-support-sidenav.component.html"
})
export class ApeSupportSidenavComponent {
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  private logger = inject(LoggerService);

  /**
   * Visibilità del drawer
   */
  @Input() visible = false;

  /**
   * Evento di cambio visibilità
   */
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor() {
    this.logger.setCaller(this.constructor.name);
  }

  /**
   * Gestisce il cambio di visibilità del drawer
   */
  onVisibleChange(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(visible);
  }
}
